
import { mapState } from 'vuex';
import Product from '@/components/shop/product.vue';

export default {
  name: 'MyPage',

  layout: 'cat',

  components: {
    Product,
  },

  data() {
    return {
      userFavoritesIds: [],
      userWatchlistIds: [],
    };
  },

  computed: {
    ...mapState([
      'myWatchlist',
      'myProducts',
      'myFavorites',
      'user',
      'products',
    ]),

    userProducts() {
      return this.products
        .filter((p) => this.myProducts.includes(p.sku))
        .slice(0, 4);
    },

    userFavorites() {
      return this.products
        .filter((p) => this.userFavoritesIds.includes(p.sku))
        .slice(0, 4);
    },

    userWatchlist() {
      return this.products
        .filter((p) => this.userWatchlistIds.includes(p.sku))
        .slice(0, 4);
    },
  },

  mounted() {
    if (this.user === null) {
      this.$router.push(this.localePath({ name: 'shop' }));
    }
    if (this.myFavorites.length) {
      this.userFavoritesIds = this.myFavorites.map((f) => f.sage_id);
    }
    if (this.myWatchlist.length) {
      this.userWatchlistIds = this.myWatchlist.map((w) => w.sku);
    }
  },
};
